import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { QuickAccessProvider } from './Components/Frontend/pages/QuickAccessContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

      <QuickAccessProvider>
        <App />
      </QuickAccessProvider>

  </React.StrictMode>
);

reportWebVitals();
